import React from "react";
import "./formik-text-area.scss";
import classNames from "classnames";
import { useField } from "formik";
import InputUnstyled from "@mui/base/InputUnstyled";
import { ValidationError } from "@thrivetribe/mvf.ui.atoms.validation-error";

export type FormikTextAreaProps = {
  name: string;
  placeholder?: string;
  className?: string;
  label?: string;
  errorMessage?: string;
  minRows?: number;
  [key: string]: any;
};

export const FormikTextArea: React.FC<FormikTextAreaProps> = ({
  className,
  label,
  name,
  errorMessage,
  minRows = 8,
  ...rest
}: FormikTextAreaProps) => {
  const [field, meta] = useField(name);

  return (
    <>
      <label className="text-area__label">
        {label}
        <div>
          <InputUnstyled
            {...field}
            multiline
            minRows={minRows}
            className={classNames("text-area", className)}
            error={!!meta.error && meta.touched}
            {...rest}
          />
        </div>
        {meta.error != undefined && meta.touched && (
          <ValidationError errorMessage={meta.error} />
        )}

        {!meta.error && meta.touched && errorMessage && <ValidationError errorMessage={errorMessage} />}
      </label>
    </>
  );
};
